import Vue from "vue";
import Router from "vue-router";

// Layouts
import OutLayout from "@/layouts/OutLayout";
import InLayout from "@/layouts/InLayout";
import PasswordLayout from "@/layouts/PasswordLayout";
import FoldersLayout from "@/layouts/FoldersLayout";

// Views
// # Authentication #
import FormSignin from "@/views/authentication/signin/FormSignin";
import Callback from "@/views/authentication/signin/Callback";
import FormRecoveryPassword from "@/views/authentication/password/FormRecoveryPassword";
import FormUpdatePassword from "@/views/authentication/password/FormUpdatePassword";

// # Account #
import FormProfile from "@/views/account/profile/FormProfile";

// # Folder #
import Archived from "@/views/folder/list/archived/Archived";
import Inbox from "@/views/folder/list/inbox/Inbox";
import Unreceived from "@/views/folder/list/unreceived/Unreceived";
import Pending from "@/views/folder/list/pending/Pending";
import Sent from "@/views/folder/list/sent/Sent";
import ShowFolder from "@/views/folder/show/ShowFolder";
import EmployeeFolder from "@/views/folder/list/employee/EmployeeFolder";
import CustomFolder from "@/views/folder/list/custom/CustomFolder";

// # Folder #
import DocumentEditor from "@/views/document/editor/DocumentEditor";

// # Settings/Dispatches #
import DispatchesList from "@/views/settings/dispatches/List";
import DispatchForm from "@/views/settings/dispatches/DispatchForm";

// # Errors
import NotFound from "@/components/error/NotFound";

// # Settings
import GeneralSettings from "@/views/settings/GeneralSettings";
import Employees from "@/views/settings/employees/List";
import Roles from "@/views/settings/roles/List";
import Notices from "@/views/settings/notices/List";
import Entities from "@/views/settings/entities/List";
import AdministrativeUnits from "@/views/settings/administrative_units/List";
import DocumentTypes from "@/views/settings/document_types/List";
import DocumentTypeForm from "@/views/settings/document_types/DocumentTypeForm";

Vue.use(Router);

const AuthGuard = (to, from, next) => {
  if (localStorage.getItem("access_token")) {
    next();
  } else {
    next("/autenticacao/entrar");
  }
};

// const ifAuthenticated = (to, from, next) => {
//   if (localStorage.getItem('access_token')) {
//     next();
//     return;
//   }
//   next('/');
// };

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/404",
      component: NotFound
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      path: "/",
      beforeEnter: AuthGuard,
      redirect: {
        name: "FoldersLayout"
      }
    },
    {
      path: "/pastas",
      name: "FoldersLayout",
      component: FoldersLayout,
      beforeEnter: AuthGuard,
      redirect: {
        name: "Inbox"
      },
      children: [
        {
          path: "entrada",
          component: Inbox,
          name: "Inbox"
        },
        {
          path: "nao-recebidos",
          component: Unreceived,
          name: "Unreceived"
        },
        {
          path: "customizada/:id",
          component: CustomFolder,
          name: "CustomFolder",
          props: true,
        },
        {
          path: "pendencias",
          component: Pending,
          name: "Pending"
        },
        {
          path: "enviados",
          component: Sent,
          name: "Sent"
        },
        {
          path: "arquivados",
          component: Archived,
          name: "Archived"
        },
        {
          path: "funcionario/:id",
          component: EmployeeFolder,
          name: "EmployeeFolder",
          props: true
        }
      ]
    },
    {
      path: "/conta",
      beforeEnter: AuthGuard,
      component: InLayout,
      name: "InLayout",
      redirect: "Profile",
      children: [
        {
          path: "perfil",
          component: FormProfile,
          name: "Profile"
        },
        {
          path: "/configuracoes/geral",
          component: GeneralSettings,
          name: "GeneralSettings"
        },
        {
          path: "/configuracoes/funcionarios",
          component: Employees,
          name: "Employees"
        },
        {
          path: "/configuracoes/cargos",
          component: Roles,
          name: "Roles"
        },
        {
          path: "/configuracoes/avisos",
          component: Notices,
          name: "Notices"
        },
        {
          path: "/configuracoes/entidades",
          component: Entities,
          name: "Entities"
        },
        {
          path: "/configuracoes/setores",
          component: AdministrativeUnits,
          name: "AdministrativeUnits"
        }
      ]
    },
    {
      path: "/pastas/:id/show",
      component: ShowFolder,
      name: "ShowFolder",
      beforeEnter: AuthGuard,
      props: true
    },
    {
      path: "/pastas/:folderId/documentos/:id",
      component: DocumentEditor,
      name: "DocumentEditor",
      beforeEnter: AuthGuard,
      props: true
    },
    {
      path: "/autenticacao",
      component: OutLayout,
      redirect: {
        name: "FormSignin"
      },
      children: [
        {
          path: "entrar",
          component: FormSignin,
          name: "FormSignin"
        },
        {
          path: "callback",
          component: Callback,
          name: "Callback"
        },
        {
          path: "senha",
          component: PasswordLayout,
          redirect: {
            name: "FormSignin"
          },
          children: [
            {
              path: "recuperar",
              component: FormRecoveryPassword
            },
            {
              path: "alterar/:token",
              component: FormUpdatePassword,
              props: true
            }
          ]
        }
      ]
    },
    {
      path: "/configuracao/despachos",
      name: "InLayout",
      component: InLayout,
      beforeEnter: AuthGuard,
      redirect: {
        name: "DispatchesList"
      },
      children: [
        {
          path: "lista",
          component: DispatchesList,
          name: "DispatchesList"
        }
      ]
    },
    {
      path: "/configuracao/despachos",
      name: "OutLayout",
      component: OutLayout,
      beforeEnter: AuthGuard,
      children: [
        {
          path: "novo",
          component: DispatchForm,
          name: "DispatchForm"
        },
        {
          path: "editar/:id",
          component: DispatchForm,
          name: "DispatchForm"
        }
      ]
    },
    {
      path: "/configuracao/documentos",
      name: "InLayout",
      component: InLayout,
      beforeEnter: AuthGuard,
      redirect: {
        name: "DocumentTypesList"
      },
      children: [
        {
          path: "lista",
          component: DocumentTypes,
          name: "DocumentTypesList"
        }
      ]
    },
    {
      path: "/configuracao/documentos",
      name: "OutLayout",
      component: OutLayout,
      beforeEnter: AuthGuard,
      children: [
        {
          path: "novo",
          component: DocumentTypeForm,
          name: "DocumentTypeForm"
        },
        {
          path: "editar/:id",
          component: DocumentTypeForm,
          name: "DocumentTypeForm"
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js